import { css } from "@emotion/css";
import { Avatar } from "@octopusdeploy/design-system-octopus-components";
import { fontWeight, space } from "@octopusdeploy/design-system-tokens";
import type { IconResource } from "@octopusdeploy/octopus-server-client";
import type { Url } from "@octopusdeploy/portal-routes";
import { repository } from "~/clientInstance";
import InternalLink from "~/components/Navigation/InternalLink";
interface TemplateNameCellProps {
    name: string;
    icon: IconResource | undefined;
    linkTarget: Url;
}
export function TemplateNameCell({ name, icon, linkTarget }: TemplateNameCellProps) {
    return (<InternalLink className={styles.nameContainer} to={linkTarget}>
            <Avatar type="template" size="medium" src={repository.Icons.getIconUrl(icon)} alt="Template icon"/>
            <div className={styles.name}>{name}</div>
        </InternalLink>);
}
const styles = {
    nameContainer: css({
        display: "flex",
        alignItems: "center",
        wordBreak: "break-word",
        gap: space[12],
    }),
    name: css({
        paddingLeft: space[6],
        fontWeight: fontWeight[600],
    }),
};
